import React from "react";

function Notes() {
  return <div>Notes</div>;
}

export default Notes;
